var _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMobilePreviewFastmanager(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "244.304px",
    height: "503.001px",
    viewBox: "0 0 244.304 503.001",
    enableBackground: "new 0 0 244.304 503.001",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_5"
  }, /*#__PURE__*/React.createElement("polyline", {
    fill: "#FFFFFF",
    points: "9.087,477.334 22.278,495.49 55.611,495.49 212.277,491 235.363,477.334 235.363,463.334  235.363,32.667 214.611,13 197.247,7 29.278,7 14.216,13.918 9.087,32.667 9.087,98 9.087,477.334  "
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#BF0A0B",
    points: "220.944,7 25.777,7 10.546,16.114 10.546,75 235.363,75 235.363,18.567  "
  }), /*#__PURE__*/React.createElement("image", {
    overflow: "visible",
    width: 208,
    height: 83,
    xlinkHref: "279F7819.jpg",
    transform: "matrix(0.3128 0 0 0.3128 14.2158 22.709)"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 90.2773 45.75)",
    fill: "#FFFFFF",
    fontFamily: "'LeelawadeeUI-Bold'",
    fontSize: 12
  }, "Vis\xE3o Geral"), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E5E5E5",
    d: "M69.277,241.334c0,3.85-3.15,7-7,7h-26c-3.85,0-7-3.15-7-7V240.5c0-3.85,3.15-7,7-7h26c3.85,0,7,3.15,7,7 V241.334z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 28.7754 219.417)",
    fill: "#BF0A0B",
    fontFamily: "'LeelawadeeUI-Bold'",
    fontSize: 12
  }, "Propostas")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 141.4424 304.417)",
    fontFamily: "'LeelawadeeUI-Bold'",
    fontSize: 12
  }, "Aprovadas")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 141.4424 344.001)",
    fontFamily: "'LeelawadeeUI-Bold'",
    fontSize: 12
  }, "Em aberto")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 39.1113 244.7549)",
    fontFamily: "'LeelawadeeUI'",
    fontSize: 12
  }, "Dia")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 82.2773 244.7549)",
    fontFamily: "'LeelawadeeUI'",
    fontSize: 12
  }, "Semana")), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 141.4414 323.0879)",
    fill: "#2E58A6",
    fontFamily: "'LeelawadeeUI'",
    fontSize: 12
  }, "88"), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 141.4414 363.7549)",
    fontFamily: "'LeelawadeeUI'",
    fontSize: 12
  }, "02")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 135.6113 244.7549)",
    fontFamily: "'LeelawadeeUI'",
    fontSize: 12
  }, "M\xEAs")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.8539 0 0 1 169.2109 244.3535)",
    fill: "#CCCCCC",
    fontFamily: "'LeelawadeeUI'",
    fontSize: 11.5402
  }, "Mai/2021")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 27.9443 270.0879)",
    fontFamily: "'LeelawadeeUI'",
    fontSize: 12
  }, "Total de propostas: 88")), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 62.2773 63.0835)",
    fill: "#FFFFFF",
    fontFamily: "'LeelawadeeUI'",
    fontSize: 12
  }, "John Smith - 0000000"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 212.2773 45.75)",
    fill: "#FFFFFF",
    fontFamily: "'LeelawadeeUI-Bold'",
    fontSize: 12
  }, "?"), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M190.711,40.243l4.908-1.375l-0.86-0.789c0,0,6.07-3.187,8.979,4.723c0,0,0.93-5.682-5.724-7.342 c0,0-3.442-0.295-5.164,0.604l-0.838-1.208L190.711,40.243z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M199.504,46.407l-0.885-0.744l4.862-1.442l-1.279,5.327l-0.745-1.093c0,0-9.831,3.644-11.072-6.808 C190.385,41.646,193.424,49.307,199.504,46.407z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#BF0A0B",
    d: "M22.278,182c0,5.5-2.968,10-6.595,10s-6.595-4.5-6.595-10V93.333c0-5.5,2.968-10,6.595-10 s6.595,4.5,6.595,10V182z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#BF0A0B",
    d: "M235.363,182c0,5.5-2.968,10-6.596,10c-3.627,0-6.595-4.5-6.595-10V93.333c0-5.5,2.968-10,6.595-10 c3.628,0,6.596,4.5,6.596,10V182z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#BF0A0B",
    d: "M214.611,182c0,5.5-4.5,10-10,10H38.775c-5.5,0-10-4.5-10-10V93.333c0-5.5,4.5-10,10-10h165.836 c5.5,0,10,4.5,10,10V182z"
  })), /*#__PURE__*/React.createElement("circle", {
    fill: "#2E58A6",
    cx: 79.277,
    cy: 344.001,
    r: 51.333
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#41AA54",
    d: "M212.277,429c0,2.75-2.25,5-5,5h-170c-2.75,0-5-2.25-5-5v-18c0-2.75,2.25-5,5-5h170c2.75,0,5,2.25,5,5 V429z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#41AA54",
    d: "M212.277,472.334c0,2.75-2.25,5-5,5h-170c-2.75,0-5-2.25-5-5v-18c0-2.75,2.25-5,5-5h170 c2.75,0,5,2.25,5,5V472.334z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 55.6108 424.417)",
    fill: "#FFFFFF",
    fontFamily: "'LeelawadeeUI-Bold'",
    fontSize: 12
  }, "Listagem de Propostas")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 72.9443 466.417)",
    fill: "#FFFFFF",
    fontFamily: "'LeelawadeeUI-Bold'",
    fontSize: 12
  }, "Nova viabilidade")), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    cx: 79.277,
    cy: 344.001,
    r: 30.666
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 58.9443 341.417)",
    fontFamily: "'LeelawadeeUI-Bold'",
    fontSize: 12
  }, "94,11%")), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 58.9443 353.0215)",
    fill: "#2E58A6",
    fontFamily: "'LeelawadeeUI-Bold'",
    fontSize: 8.5268
  }, "Aprovadas"), /*#__PURE__*/React.createElement("path", {
    fill: "#B3B3B3",
    d: "M108.514,334.729l19.138-7.939c0,0,3.785,10.253,2.789,21.398l-20.629-1.359 C109.812,346.828,110.75,344.54,108.514,334.729z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163.277,
    y: 231.584,
    fill: "#E5E5E5",
    width: 0.5,
    height: 18.666
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.278,
    y: 226,
    fill: "#E5E5E5",
    width: 183,
    height: 0.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.725,
    y: 254.25,
    fill: "#E5E5E5",
    width: 183,
    height: 0.32
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 15,
    strokeMiterlimit: 10,
    d: "M235.363,464.49c0,17.05-13.95,31-31,31H40.087 c-17.05,0-31-13.95-31-31V39.02c0-17.05,13.95-31,31-31h164.276c17.05,0,31,13.95,31,31V464.49z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 241.75,
    y: 75,
    width: 2.554,
    height: 67.917
  }), /*#__PURE__*/React.createElement("rect", {
    x: 241.75,
    y: 158.501,
    width: 2.554,
    height: 41.499
  }), /*#__PURE__*/React.createElement("rect", {
    y: 158.501,
    width: 2.554,
    height: 41.499
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    d: "M128.552,26.334c0,3.498-2.542,6.333-5.679,6.333h-1.295c-3.136,0-5.679-2.835-5.679-6.333l0,0 c0-3.498,2.543-6.333,5.679-6.333h1.295C126.01,20,128.552,22.836,128.552,26.334L128.552,26.334z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333333",
    d: "M124.931,26.334c0,1.496-1.087,2.708-2.428,2.708h-0.555c-1.341,0-2.428-1.212-2.428-2.708l0,0 c0-1.496,1.087-2.708,2.428-2.708h0.555C123.844,23.625,124.931,24.838,124.931,26.334L124.931,26.334z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobilePreviewFastmanager);
export default __webpack_public_path__ + "static/media/MobilePreviewFastmanager.1922df03ae167a8e9434a98dc3d18145.svg";
export { ForwardRef as ReactComponent };